import React from 'react';

/** Confirmação simples no padrão dos modais do sistema. */
const ConfirmModal = ({
  aberto,
  titulo,
  children,
  confirmLabel = 'Confirmar',
  perigo = false,
  busy = false,
  onConfirm,
  onCancel,
}) => {
  if (!aberto) return null;
  return (
    <div className="modal-overlay" onClick={() => !busy && onCancel()}>
      <div className="modal modal-sm esc-confirm" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{titulo}</h2>
          <button className="modal-close" onClick={onCancel} disabled={busy} aria-label="Fechar">
            &times;
          </button>
        </div>
        <div className="confirmation-body">
          {children}
          <div className="modal-actions">
            <button type="button" className="btn-secondary" onClick={onCancel} disabled={busy}>
              Cancelar
            </button>
            <button
              type="button"
              className={perigo ? 'btn-danger' : 'btn-primary'}
              onClick={onConfirm}
              disabled={busy}
            >
              {busy ? 'Aguarde…' : confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
